<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button routerLink="/">
        <ion-icon name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="custom">
      Custom Tuning
    </ion-title>
    <ion-buttons slot="end">
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  
  <div class="label" *ngIf="custom">
    Use the left & right arrows to change tune ...
  </div>
  <h2 *ngIf="!custom" [style.margin]="'20px 12px 12px 12px'">
    {{tuning.name}}
  </h2>

  <ion-grid *ngIf="!custom" class="incard">
    <ion-row>
      <ion-col 
        size="4"
        [style.font-size]="'.9em'">
        Tuning:
      </ion-col>
      <ion-col 
        *ngFor="let note of tuning.notes.replace('2','').split(' ')" 
        [ngStyle]="{
          'color': 'blue',
          'font-size': '90%'
        }" 
        text-center>
        {{note}}
      </ion-col>
    </ion-row>
    <ion-row *ngIf="tuning.intervals.length > 0">
      <ion-col 
        size="4"
        [style.font-size]="'.9em'">
        Intervals:
      </ion-col>
      <ion-col 
        *ngFor="let interval of tuning.intervals.split(' ')"
        text-center>
        {{interval}}
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-card-content *ngIf="!custom">
    <app-tuning-text
      [tuning]="tuning">
    </app-tuning-text>
  </ion-card-content>
  <div class="fretboard">
    <fretboard
      [displayParams]="{
        'lefty': opt.lefty,
        'doremi': opt.doremi,
        'withDetuneStrings': false,
        'withTuners': custom,
        'openTuning6': tuning.notes
      }"
      [tunerOptionLabels]="['Reset custom tuning', '', '']"
      [displayChordScale]="CSValue">
    </fretboard>
  </div>
  <div class="label">
    Select a chord or scale to display with this tuning ...
    <span *ngIf="showReset()">&nbsp;-&nbsp;
      <a (click)="reset()" [style.cursor]="'pointer'">
        No chord or scale
      </a>
    </span>
  </div>
  <div class="incard">
    <ion-select
      (ionChange)="refreshFretboard()"
      [(ngModel)]="selectedNote12String" placeholder="Root note">
      <ion-select-option 
        value="{{note12}}"
        *ngFor="let root of notesService.all; let note12 = index">
        {{root}}
      </ion-select-option>
    </ion-select>
    <ion-select
      (ionChange)="refreshFretboard()"
      [(ngModel)]="selectedCSIndexString" placeholder="Chord / Scale">
      <ion-select-option 
        value="{{i}}"
        *ngFor="let cs of CS; let i = index">
        {{cs}}
      </ion-select-option>
    </ion-select>
  </div>
  <br/><br/><br/>
</ion-content>
